"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerLinksApi = exports.PartnerLinksApiFactory = exports.PartnerLinksApiFp = exports.PartnerLinksApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * PartnerLinksApi - axios parameter creator
 * @export
 */
var PartnerLinksApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Permanently deletes the partner link. Supply the unique id that was returned when you created the partner link and this will delete it.
         * @summary Delete the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerLink: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deletePartnerLink', 'id', id);
                            localVarPath = "/insuranceservice/v1/partner-link/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the partner link that was previously created.        Supply the unique partner link id that was returned when you created it and Emil Api will return the corresponding partner link information.
         * @summary Retrieve the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] You can expand partner link in this endpoint. \&#39; +       \&#39;Allowed values: role, partner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerLink: function (id, authorization, expand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getPartnerLink', 'id', id);
                            localVarPath = "/insuranceservice/v1/partner-link/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will create a partner link.
         * @summary Create the partner link
         * @param {LinkPartnerRequestDto} linkPartnerRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkPartner: function (linkPartnerRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'linkPartnerRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('linkPartner', 'linkPartnerRequestDto', linkPartnerRequestDto);
                            localVarPath = "/insuranceservice/v1/partner-link";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(linkPartnerRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of partner links you have previously created.          The partner links are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List partner links
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {string} [search] Search the response for matches in any searchable field.            Use filter instead where possible for improved performance.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Searchable fields: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: role.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerLinks: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/partner-link";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Ends the partner link setting the end date of the specified partner link to today.
         * @summary Ends the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkPartner: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('unlinkPartner', 'id', id);
                            localVarPath = "/insuranceservice/v1/partner-link/{id}/unlink"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified partner link by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the partner link
         * @param {number} id
         * @param {UpdatePartnerLinkRequestDto} updatePartnerLinkRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerLink: function (id, updatePartnerLinkRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updatePartnerLink', 'id', id);
                            // verify required parameter 'updatePartnerLinkRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('updatePartnerLink', 'updatePartnerLinkRequestDto', updatePartnerLinkRequestDto);
                            localVarPath = "/insuranceservice/v1/partner-link/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePartnerLinkRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PartnerLinksApiAxiosParamCreator = PartnerLinksApiAxiosParamCreator;
/**
 * PartnerLinksApi - functional programming interface
 * @export
 */
var PartnerLinksApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PartnerLinksApiAxiosParamCreator)(configuration);
    return {
        /**
         * Permanently deletes the partner link. Supply the unique id that was returned when you created the partner link and this will delete it.
         * @summary Delete the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerLink: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePartnerLink(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the partner link that was previously created.        Supply the unique partner link id that was returned when you created it and Emil Api will return the corresponding partner link information.
         * @summary Retrieve the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] You can expand partner link in this endpoint. \&#39; +       \&#39;Allowed values: role, partner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerLink: function (id, authorization, expand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartnerLink(id, authorization, expand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will create a partner link.
         * @summary Create the partner link
         * @param {LinkPartnerRequestDto} linkPartnerRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkPartner: function (linkPartnerRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.linkPartner(linkPartnerRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of partner links you have previously created.          The partner links are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List partner links
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {string} [search] Search the response for matches in any searchable field.            Use filter instead where possible for improved performance.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Searchable fields: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: role.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerLinks: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPartnerLinks(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Ends the partner link setting the end date of the specified partner link to today.
         * @summary Ends the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkPartner: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unlinkPartner(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified partner link by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the partner link
         * @param {number} id
         * @param {UpdatePartnerLinkRequestDto} updatePartnerLinkRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerLink: function (id, updatePartnerLinkRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePartnerLink(id, updatePartnerLinkRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PartnerLinksApiFp = PartnerLinksApiFp;
/**
 * PartnerLinksApi - factory interface
 * @export
 */
var PartnerLinksApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PartnerLinksApiFp)(configuration);
    return {
        /**
         * Permanently deletes the partner link. Supply the unique id that was returned when you created the partner link and this will delete it.
         * @summary Delete the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerLink: function (id, authorization, options) {
            return localVarFp.deletePartnerLink(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the partner link that was previously created.        Supply the unique partner link id that was returned when you created it and Emil Api will return the corresponding partner link information.
         * @summary Retrieve the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {string} [expand] You can expand partner link in this endpoint. \&#39; +       \&#39;Allowed values: role, partner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerLink: function (id, authorization, expand, options) {
            return localVarFp.getPartnerLink(id, authorization, expand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will create a partner link.
         * @summary Create the partner link
         * @param {LinkPartnerRequestDto} linkPartnerRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkPartner: function (linkPartnerRequestDto, authorization, options) {
            return localVarFp.linkPartner(linkPartnerRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of partner links you have previously created.          The partner links are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
         * @summary List partner links
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {string} [search] Search the response for matches in any searchable field.            Use filter instead where possible for improved performance.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Searchable fields: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.           Expanding resources can reduce the number of API calls required to accomplish a task.           Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: role.&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: partnerCode, partnerRoleCode, policyCode, leadCode&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerLinks: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listPartnerLinks(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Ends the partner link setting the end date of the specified partner link to today.
         * @summary Ends the partner link
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkPartner: function (id, authorization, options) {
            return localVarFp.unlinkPartner(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified partner link by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the partner link
         * @param {number} id
         * @param {UpdatePartnerLinkRequestDto} updatePartnerLinkRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerLink: function (id, updatePartnerLinkRequestDto, authorization, options) {
            return localVarFp.updatePartnerLink(id, updatePartnerLinkRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PartnerLinksApiFactory = PartnerLinksApiFactory;
/**
 * PartnerLinksApi - object-oriented interface
 * @export
 * @class PartnerLinksApi
 * @extends {BaseAPI}
 */
var PartnerLinksApi = /** @class */ (function (_super) {
    __extends(PartnerLinksApi, _super);
    function PartnerLinksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Permanently deletes the partner link. Supply the unique id that was returned when you created the partner link and this will delete it.
     * @summary Delete the partner link
     * @param {PartnerLinksApiDeletePartnerLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLinksApi
     */
    PartnerLinksApi.prototype.deletePartnerLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerLinksApiFp)(this.configuration).deletePartnerLink(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the partner link that was previously created.        Supply the unique partner link id that was returned when you created it and Emil Api will return the corresponding partner link information.
     * @summary Retrieve the partner link
     * @param {PartnerLinksApiGetPartnerLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLinksApi
     */
    PartnerLinksApi.prototype.getPartnerLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerLinksApiFp)(this.configuration).getPartnerLink(requestParameters.id, requestParameters.authorization, requestParameters.expand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will create a partner link.
     * @summary Create the partner link
     * @param {PartnerLinksApiLinkPartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLinksApi
     */
    PartnerLinksApi.prototype.linkPartner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerLinksApiFp)(this.configuration).linkPartner(requestParameters.linkPartnerRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of partner links you have previously created.          The partner links are returned in sorted order, with the oldest one appearing first.          For more information about pagination, read the Pagination documentation.
     * @summary List partner links
     * @param {PartnerLinksApiListPartnerLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLinksApi
     */
    PartnerLinksApi.prototype.listPartnerLinks = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PartnerLinksApiFp)(this.configuration).listPartnerLinks(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Ends the partner link setting the end date of the specified partner link to today.
     * @summary Ends the partner link
     * @param {PartnerLinksApiUnlinkPartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLinksApi
     */
    PartnerLinksApi.prototype.unlinkPartner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerLinksApiFp)(this.configuration).unlinkPartner(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified partner link by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the partner link
     * @param {PartnerLinksApiUpdatePartnerLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerLinksApi
     */
    PartnerLinksApi.prototype.updatePartnerLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerLinksApiFp)(this.configuration).updatePartnerLink(requestParameters.id, requestParameters.updatePartnerLinkRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PartnerLinksApi;
}(base_1.BaseAPI));
exports.PartnerLinksApi = PartnerLinksApi;
